import React from 'react';
import { connect } from 'react-redux';
import { lzBytesToSize } from '../../../../../services/LzUtils';
import { lzCallApi } from '../../../../../services/LzApiService';
import Dropzone from 'react-dropzone'
import MediaModel from '../../../../../models/media';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import LinearProgress from '@material-ui/core/LinearProgress';
import { lzGetTimestamp } from '../../../../../services/LzMoment';

class MediaUploaderComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            files: [],                                  // Files in state that are selected for upload (after upload attempt, failed files are kept and successfully uploaded are removed)
            isUploading: false,                         // Flag to tell if uploading is in progress
            fileUploadingIndex: -1,                     // Index of currently being uploaded file
            fileUploadingProgress: -1,                  // Progress of currently being uploaded file
            fileUploadingFailures: [],                  // Holds indices of files failed during uploading, so that an alert can be shown on them (after uploading is finished we will only keep the failed files and show errors on them)
            filesErrors: [],                            // Errors on files based on their index (this is the new index because some file upload may have been successful and those files should have been removed from the main array)
        };

        this.simulateUpload = false;                    // Just set this for testing of upload simulation instead of actual upload (MUST BE FALSE IN PRODUCTION)
    }

    onFilesSelected(files) {
        const newFiles = this.state.files.slice();
        newFiles.push(...files);
        this.setState({ files: newFiles });
    }

    onFileRemove(dex) {
        const newFiles = this.state.files.slice();
        newFiles.splice(dex, 1);
        this.setState({ files: newFiles });
    }

    async onUploadFiles() {
        const { onUploaded } = this.props;

        // Files to process
        const { files } = this.state;

        // Array of medias for return
        const medias = [];

        // Failed files
        const failedFiles = [];
        const filesErrors = [];

        // Load up the progress
        this.setState({ isUploading: true, fileUploadingIndex: 0, fileUploadingProgress: -1, fileUploadingFailures: [], filesErrors: [] });

        // Go through all files to process
        let i = 0;
        for (const file of files) {
            i++;

            // Try to upload file and get media in return
            const media = await this.uploadFile(file);
            console.log('UPLOAD-RESULT', media, this.props.lastErrorMessage);
            const stateUpdates = { fileUploadingIndex: i, fileUploadingFailures: [] };

            // If failed then error message is returned as string
            if (typeof media === 'boolean') {
                failedFiles.push(file);                         // Save the failed file object for retry
                filesErrors.push(this.props.lastErrorMessage);  // Save the error for that file
                stateUpdates.fileUploadingFailures[i - 1] = true;
            }

            // If it was not an error then push to medias
            else {
                medias.push(new MediaModel(media));
            }

            // Update the progress-bar and error response during uploading
            this.setState(stateUpdates);
        }

        // Finish up the progress bar and set results
        this.setState({
            files: failedFiles,
            isUploading: false,
            fileUploadingIndex: -1,
            fileUploadingProgress: -1,
            fileUploadingFailures: [],
            filesErrors: filesErrors,
        });

        if (onUploaded) {
            onUploaded(medias, filesErrors);
        }
    }

    async uploadFile(file) {
        const { isPrivate, category } = this.props;

        this.setState({ fileUploadingProgress: 0 });

        if (this.simulateUpload) {
            for (let i = 0; i < 100; i++) {
                let c = 0;
                for (let j = 0; j < 99999; j++) {
                    c = lzGetTimestamp();
                }
                console.log('PROGRESS:', i, c);
                this.setState({ fileUploadingProgress: i });
                if (Math.random() < 0.1) {
                    return 'Random error uploading file!';
                }
            }
            return {}; // success
        }

        // Make the api call to upload the file
        const data = await lzCallApi('media', {
            file: file,
            category: category || 'general',
            is_private: !!isPrivate,
        }, 'post', false, true, (p) => {
            this.setState({ fileUploadingProgress: p && p.total && p.total > 0 ? Math.round(p.loaded / p.total * 100) : 0 });
        });

        // Load data if call was successful
        if (data) {
            return data;
        }

        return false;
    }

    onClearAllFiles() {
        this.setState({ files: [] });
    }

    render() {
        const { files, isUploading, fileUploadingIndex, fileUploadingProgress, fileUploadingFailures, filesErrors } = this.state;
        const { accept, minSize, maxSize, maxFiles } = this.props;

        console.log('FILES', files);

        return (
            <div style={{ display: 'flex', flexDirection: 'column', margin: '1em', height: 'calc(100% - 3em)' }}>

                {(files && files.length > 0) &&
                    <Paper
                        variant="outlined"
                        style={{
                            padding: '0.6em',
                            margin: '0 -1em 0.6em -1em',
                        }}
                    >
                        <Grid container spacing={1}>
                            {files.map((file, dex) =>
                                <Grid item key={'file-' + dex} style={{ flexGrow: 1, maxWidth: 240 }}>
                                    <Card variant="outlined" className="lz-media-card">
                                        <CardHeader
                                            action={
                                                <IconButton disabled={isUploading} onClick={() => this.onFileRemove(dex)}>
                                                    <ClearIcon />
                                                </IconButton>
                                            }
                                            title={file.name}
                                            subheader={lzBytesToSize(file.size)}
                                        />
                                        <CardMedia
                                            image={MediaModel.isImageByContentType(file.type) ? MediaModel.getImageIconByFile(file) : null}
                                            children={!MediaModel.isImageByContentType(file.type) ? MediaModel.getImageIconByFile(file) : null}
                                            title={file.name}
                                        />
                                        <CardContent>
                                            {filesErrors[dex] && <Alert severity="error">{filesErrors[dex]}</Alert>}
                                            {isUploading &&
                                                <LinearProgress
                                                    variant="determinate"
                                                    color={fileUploadingFailures.indexOf(dex) < 0 ? 'primary' : 'secondary'}
                                                    value={dex === fileUploadingIndex ? fileUploadingProgress : (fileUploadingIndex < dex ? 0 : 100)}
                                                />
                                            }
                                        </CardContent>
                                    </Card>
                                </Grid>
                            )}
                        </Grid>
                        <Grid container justifyContent="flex-end" spacing={1} style={{ paddingTop: 12 }}>
                            <Grid item style={{ flexGrow: 1, alignSelf: 'center' }}>
                                {isUploading && <LinearProgress variant="determinate" value={Math.round((fileUploadingIndex / files.length) * 100)} />}
                            </Grid>
                            <Grid item>
                                <Button disabled={isUploading} onClick={() => this.onClearAllFiles()}>Clear All</Button>
                            </Grid>
                            <Grid item>
                                <Button disabled={isUploading} color="primary" variant="contained" onClick={() => this.onUploadFiles()}>Upload</Button>
                            </Grid>
                        </Grid>
                    </Paper>
                }

                {false && <pre>{JSON.stringify(this.state, null, 4)}</pre>}

                <Dropzone
                    accept={accept}
                    minSize={minSize}
                    maxSize={maxSize}
                    maxFiles={maxFiles}
                    onDrop={acceptedFiles => this.onFilesSelected(acceptedFiles)}
                >
                    {({ getRootProps, getInputProps }) => (
                        <section
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                margin: '0 -1em',
                                height: '100%',
                                border: '2px dashed #c0c0c0',
                            }}
                        >
                            <div {...getRootProps()}
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: '100%',
                                    height: '100%',
                                }}
                            >
                                <input {...getInputProps()} />
                                <Typography variant="overline" display="block" style={{ textAlign: 'center' }}>
                                    Drag 'n' drop some files here, or click to select files
                                </Typography>

                            </div>
                        </section>
                    )}
                </Dropzone>

            </div>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        lastErrorMessage: state.commons.lastErrorMessage,
    }
};

export default connect(
    mapStateToProps
)(MediaUploaderComponent);
